import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Themes extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Themes";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {

      name: null,
      description: null,


      mid_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (data.dark_mode === 'DARK') data.dark_mode = true
    if (data.dark_mode === 'LIGHT') data.dark_mode = false
    if (data.dark_mode === 'INHERIT') {
      const prefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      prefersDarkMode ? data.dark_mode = true : data.dark_mode = false
    }

    console.log("[THEME SERVICE]", data);
    return data;
  }
}
